import type { Language } from "../i18n";
import { t } from "../i18n";

// Manual current-store picker (spec §31 — MVP does not do geolocation/store detection).
// Slugs match the shop_slug values fit-parsers writes to the catalog.
const STORE_OPTIONS: Array<{ id: string; label: string }> = [
  { id: "selver", label: "Selver" },
  { id: "rimi", label: "Rimi" },
  { id: "prisma", label: "Prisma" },
  { id: "lidl", label: "Lidl" },
  { id: "coop", label: "Coop" },
  { id: "maxima", label: "Maxima" },
  { id: "depo", label: "DEPO" },
  { id: "barbora", label: "Barbora" },
  { id: "ostukorvid", label: "Ostukorvid" },
];

export interface StoreSelectProps {
  value: string | undefined;
  onChange: (storeId: string | undefined) => void;
  language?: Language;
}

export function StoreSelect({ value, onChange, language = "ru" }: StoreSelectProps) {
  const placeholder = t(language, "store_select_placeholder");
  const ariaLabel = t(language, "store_select_aria");

  return (
    <select
      className="store-select"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value || undefined)}
      aria-label={ariaLabel}
      data-testid="store-select"
    >
      <option value="">{placeholder}</option>
      {STORE_OPTIONS.map((store) => (
        <option key={store.id} value={store.id}>
          {store.label}
        </option>
      ))}
    </select>
  );
}
